// https://stackoverflow.com/a/32402438
export const matchRule = (str: string, rule: string): boolean => {
  const escapeRegex = (str): string => str.replace(/([.*+?^=!:${}()|[\]/\\])/g, "\\$1")
  return new RegExp("^" + rule.split("*").map(escapeRegex).join(".*") + "$").test(str)
}
